export type EventData = {
  action: string;
  payload?: object;
};

type EventListener = (eventData: EventData) => void;

class EventDispatcher {
  private listeners: EventListener[] = [];

  subscribe(listener: EventListener) {
    this.listeners.push(listener);
  }

  publish(eventData: EventData) {
    this.listeners.forEach((listener) => listener(eventData));
  }

  unsubscribe(listener: EventListener) {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }
}

export const eventDispatcher = new EventDispatcher();
